import { render, staticRenderFns } from "./CustomerViewInspections.vue?vue&type=template&id=9ed04364"
import script from "./CustomerViewInspections.vue?vue&type=script&lang=js"
export * from "./CustomerViewInspections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports